import watching from "./watching.png";

const Precopy = () => {
  return (
    <div className="pre-copy">
      <img
        className="img-fluid"
        src={watching}
        loading="lazy"
        style={{ background: "linear-gradient(#040113 0%, #151322 100%)" }}
        alt="watching"
      />
    </div>
  );
};

export default Precopy;
